import { render, staticRenderFns } from "./question-and-answer-grid-04.vue?vue&type=template&id=f05720ce&scoped=true&"
import script from "./question-and-answer-grid-04.vue?vue&type=script&lang=js&"
export * from "./question-and-answer-grid-04.vue?vue&type=script&lang=js&"
import style0 from "./question-and-answer-grid-04.vue?vue&type=style&index=0&id=f05720ce&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05720ce",
  null
  
)

export default component.exports